import React, { FC } from 'react';
import styles from './styles.module.css';
import { GetChallengesResponseType } from 'Rewards/services/endpoints/GetChallenges/types';
import { ChallengeCard } from '../ChallengeCard/ChallengeCard';
import { AchievementsCard } from '../AchievementsCard/AchievementsCard';

export const Challenges: FC<{
  challengesData: GetChallengesResponseType;
  rewardsCenterRefresh: () => void;
}> = ({ challengesData, rewardsCenterRefresh }) => {
  let challengesPriority: Array<
    GetChallengesResponseType['challenges'][number] | undefined
  > = [];

  challengesPriority.push(
    challengesData.challenges.find(
      (challenge) =>
        challenge.challengeStatus?.status === 'ACTIVE' &&
        challenge.tiers.length > 0
    )
  );

  challengesPriority.push(
    challengesData.challenges.find(
      (challenge) =>
        challenge.challengeStatus?.status === 'UPCOMING' &&
        challenge.tiers.length > 0
    )
  );

  challengesPriority.push(
    challengesData.challenges.find(
      (challenge) =>
        challenge.challengeStatus?.status === 'COMPLETED' &&
        challenge.tiers.length > 0
    )
  );

  const challengeToDisplay = challengesPriority.filter((val) => !!val)[0];

  return (
    <div className={styles.challengesContainer}>
      {!challengeToDisplay ? (
        <div className={styles.emptyCard} />
      ) : (
        <ChallengeCard
          challenge={challengeToDisplay}
          rewardsCenterRefresh={rewardsCenterRefresh}
        />
      )}
      <AchievementsCard achievements={challengesData.achievements} />
    </div>
  );
};
